/* istanbul ignore file: tested in sled */
import {RichContent, isRichContent} from '@wix/ricos';

export const getRicoRichContent = (content: string) => {
  try {
    const richContent = JSON.parse(content) as RichContent;
    return isRichContent(richContent) ? richContent : null;
  } catch {
    return null;
  }
};
